import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=c2fdbd80&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
import style0 from "./Plans.vue?vue&type=style&index=0&id=c2fdbd80&prod&lang=scss&scoped=true"
import style1 from "./Plans.vue?vue&type=style&index=1&id=c2fdbd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fdbd80",
  null
  
)

export default component.exports